<template>
<component :is="notModal ? 'div' : 'modal'" :title="item.gli + ' Resolve'" v-if="!!item" ref="modal" height="300px">
  <template #top>
    <div>{{ item.description }}</div>
  </template>
  <audit-item @done="finished" v-if="!task" :audit="audit" :item="item" @task="t => task = t"/>
  <audit-resolve v-else v-bind="{...task, item}" @done="done"/>
</component>
</template>

<script>
export default {
  name: "audit-item-details",
  data()  {
    return {
      item: null,
      task: null
    }
  },

  props: {
    auditable: null,
    notModal: Boolean,
    noclose: Boolean
  },

  components: {
    AuditItem: () => import('./audit-item.vue'),
    AuditResolve: () => import('./audit-resolve.vue')
  },

  created() {
    this.load()
  },

  computed: {
    audit() {
      return this.item.audit //this.item.audit.filter(i => (i.over || i.under) && (!i.cleared))
    }
  },

  methods: {
    finished() {
      !this.noclose && this.$emit('submit')
    },
    done() {
      this.item = null
      this.task = null
      this.load();
    },
    async load() {
      this.item = await this.asyncAction('/api/' + this.auditable.countable_type + '/' + this.auditable.countable_id + '?with[]=audit', 'get')
      this.$nextTick(() => {
        if (this.audit.length == 0)
          this.finished()
      })
    }
  }
}
</script>

<style scoped>

</style>